import React, { Suspense } from 'react';
import { BrowserRouter, Route } from 'react-router-dom';
import List from './List';
const Simulator = React.lazy(() => import('./Simulator'));

const App = () => {
	return (
		<div>
			<BrowserRouter>
				<Suspense
					fallback={
						<div className="spinner-border" role="status" style={{ marginTop: '22%', marginLeft: '50%' }}>
							<span className="sr-only">Loading...</span>
						</div>
					}
				>
					<Route path="/" exact component={List} />
					<Route path="/:theme/:activity" exact component={Simulator} />
				</Suspense>
			</BrowserRouter>
		</div>
	);
};

export default App;
